import axios from "axios";
import apiUrl from "../apiURL";
import axiosInstance from "../axiosInstance";

const USER_TOKEN_KEY = 'userToken';
const GUEST_TOKEN_KEY = 'guestToken';

export function getAuthToken() {
  return localStorage.getItem(USER_TOKEN_KEY) || localStorage.getItem(GUEST_TOKEN_KEY);
}

export function isUserLoggedIn() {
  return !!localStorage.getItem(USER_TOKEN_KEY);
}

export function setUserToken(token) {
  localStorage.setItem(USER_TOKEN_KEY, token);
  localStorage.removeItem(GUEST_TOKEN_KEY); // clean up guest token
  localStorage.setItem('isLoggedIn', true);
  localStorage.setItem('isGuestUser', false);
}

export function setGuestToken(token) {
  localStorage.setItem(GUEST_TOKEN_KEY, token);
  localStorage.setItem('isGuestUser', true);
  localStorage.setItem('isLoggedIn', false);
}

export function clearAllTokens() {
  localStorage.removeItem(USER_TOKEN_KEY);
  localStorage.removeItem(GUEST_TOKEN_KEY);
  localStorage.removeItem('isGuestUser');
  localStorage.removeItem('isLoggedIn');
}

export async function fetchGuestToken() {
  const response = await axiosInstance.get(apiUrl.auth.guestToken);
  const token = response.data.accessToken;
  // console.log("Guest token:", token);
  setGuestToken(token);
  return token;
}